import React from 'react'
import PropTypes from 'prop-types'
import ReactModal from 'react-modal'

function PaymentModal({phone, store, onClose}) {
  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '10px',
      width: '30%'
    },
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.7)'
    },
  }

  const payContent = () => {
    return [
      <span className='payment-modal__header' key='header'>Payment Information</span>,
      <span className='payment-modal__info' key='row1'>
        Full payment is required to book this field
      </span>,
      <span className='payment-modal__info' key='row2'>
        {`Reservation can be cancelled by calling us at ${phone} more than 24 hours in advance in order to receive a full refund`}
      </span>
    ]
  }

  const storeContent = () => {
    return [
      <span className='payment-modal__header' key='header'>Store Payment Information</span>,
      <span className='payment-modal__info' key='row1'>
        Your portion of the field payment will be processed once the game is complete
      </span>,
      <span className='payment-modal__info' key='row2'>
        Please note that your card will be charged in full if the game was not cancelled and no one shows up to the game
      </span>,
      <span className='payment-modal__info' key='row3'>
        {`Reservation can be cancelled by calling us at ${phone} more than 24 hours in advance to avoid a cancelation fee`}
      </span>
    ]
  }

  return <ReactModal isOpen={true} onRequestClose={onClose} style={customStyles}>
    <div className='payment-modal'>
      <span className='payment-modal__icon'><i className='fa fa-solid fa-dollar'></i></span>
      { store ? storeContent() : payContent() }
      <button className='btn btn-ok' onClick={onClose}>Ok</button>
    </div>
  </ReactModal>
}

PaymentModal.propTypes = {
  phone: PropTypes.string.isRequired,
  store: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
}

export default PaymentModal
